import script from "./ImageManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageManager.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__